export enum actionTypes {
    CASINO_COMPONENT_INTEGRATION_SCRIPT_LOADED_TOGGLE = 'CASINO_COMPONENT:INTEGRATION_SCRIPT_LOADED:TOGGLE'
}
